import {
  ConsultantQualityCheckDataFragment,
  ConsultantQuality_ConsultantNewFragment
} from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";

export type DisabledButtonOption = "no-ssn" | "ivo-grund-approved";

export interface DisabledButtonConfig {
  data: ConsultantQualityCheckDataFragment;
  consultantData?: ConsultantQuality_ConsultantNewFragment;
  options?: DisabledButtonOption[];
}

export function getDisabledQualityCheckButton(config: DisabledButtonConfig): {
  isDisabled: boolean;
  disabledInfo?: string;
} {
  const { data, consultantData, options = [] } = config;

  let isDisabled = data.Disabled;
  let disabledInfo: string | undefined;

  if (options.includes("ivo-grund-approved")) {
    if (data.Name === "IVO-Grund" && data.Status?.Name === "Approved") {
      isDisabled = true;
    }
  }

  // Check SSN requirement
  if (options.includes("no-ssn")) {
    const hasSSN = consultantData?.SocialSecurityNo;
    if (!hasSSN) {
      isDisabled = true;
      disabledInfo = locale.missingSSNForOrdering;
    }
  }

  return {
    isDisabled,
    disabledInfo
  };
}
